import React, { useState, useMemo } from "react";
import Table from "../../CommonComponents/Table";
import constants from "../../../constants";
import Badge from "../../CommonComponents/Badge";
import Tooltip from "../../CommonComponents/Tooltip";
function BatchListView(Props) {

  const InfoIcon = () => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.39329 5.33366C5.55003 4.8881 5.85939 4.5124 6.2666 4.27308C6.6738 4.03376 7.15256 3.94628 7.61808 4.02613C8.0836 4.10598 8.50584 4.34801 8.81001 4.70934C9.11418 5.07068 9.28066 5.52801 9.27996 6.00033C9.27996 7.33366 7.27996 8.00033 7.27996 8.00033M7.33329 10.667H7.33996M14 7.33366C14 11.0156 11.0152 14.0003 7.33329 14.0003C3.65139 14.0003 0.666626 11.0156 0.666626 7.33366C0.666626 3.65176 3.65139 0.666992 7.33329 0.666992C11.0152 0.666992 14 3.65176 14 7.33366Z" stroke="#98A2B3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );

  const typeFilter = Props.typeFilter;

  /*
  ---------------------------
  Table Columns Configuration
  ---------------------------
  */
  const columns = useMemo(() => {
    if (Props.from === "batch") {
      const cols = [
        { key: "name", title: "Batch Name", className: "batchName" },
        { key: "createdby", title: "Created By", className: "createdBy" },
        { key: "startdate", title: "Start Date", className: "startDate" },
        {
          key: "useorder",
          title: "Sequential Curriculum",
          className: "sequential",
          renderHeader: () => (
            <div style={{ display: "flex", alignItems: "center", gap: "6px",justifyContent:"center", width:"100%" }}>
              Sequential Curriculum
              <Tooltip title="Learners must complete modules in sequence">
                <span style={{ display: "flex", alignItems: "center" }}>
                  <InfoIcon />
                </span>
              </Tooltip>
            </div>
          )
        }
      ];

      // only show the `Type` column when the filter is “All”
      if (typeFilter === "All") {
        cols.push({
          key: "type",
          title: "Type",
          className: "type",
          render: (value) => {
            let color = "grey";
            if (value === "Live Class") color = "primary";
            if (value === "Evaluation") color = "success";
            if (value === "Self-Paced") color = "indigo";
            return <Badge size="sm" label={value} color={color} />;
          }
        });
      }

      return cols;
    }

    return [
      { key: "name", title: "Learning Path Name", className: "lpName" },
      { key: "createdby", title: "Created By", className: "createdBy" }
    ];
  }, [Props.from, typeFilter]);

  /*
  ---------------------------
  Filter + Format Data
  ---------------------------
  */

  const filteredData = useMemo(() => {
    if (Props.from === "batch") {
      return Props.data
        .filter((bat) => {
          if (bat.archived != Props.showArchived) return false;

          if (typeFilter === "All") return true;

          if (
            typeFilter === "Evaluation" &&
            bat.type === constants.BATCH_TYPE.TESTING
          )
            return true;

          if (
            typeFilter === "Learning" &&
            bat.type === constants.BATCH_TYPE.LEARNING
          )
            return true;

          if (
            typeFilter === "Self-Paced" &&
            bat.type !== constants.BATCH_TYPE.TESTING &&
            bat.type !== constants.BATCH_TYPE.LEARNING
          )
            return true;

          return false;
        })
        .map((batch) => {
          return {
            ...batch,

            createdby: batch.createdby !== "null" ? batch.createdby : "-",

            startdate: new Date(batch.startdate).toLocaleDateString("en-GB"),

            type:
              batch.type === constants.BATCH_TYPE.TESTING
                ? "Evaluation"
                : batch.type === constants.BATCH_TYPE.LEARNING
                  ? "Live Class"
                  : "Self-Paced",

            useorder: batch.useorder === 0 ? "No" : "Yes",
          };
        });
    }

    return Props.data
      .filter((lp) => lp.archived === Props.showArchivedLps)
      .map((lp) => ({
        ...lp,
        createdby: lp.createdby !== "null" ? lp.createdby : "-",
      }));
  }, [Props, typeFilter]);

  /*
  ---------------------------
  Row Click Handler
  ---------------------------
  */

  const handleRowClick = (row) => {
    console.log("Row Clicked ----> :", row);
    if (Props.from === "batch") {
      Props.handleBatchDetails(row.id, row.startdate,row.type);
    } else {
      Props.handleSpecificLp(row.id, row.name);
    }
  };

  return (
    <div
      className={
        Props.from === "batch"
          ? "listBatchViewContainer"
          : "listLpViewContainer"
      }
    >
      {/* Filter Buttons */}



      {/* Table Component */}

      <Table
        columns={columns}
        data={filteredData}
        onRowClick={handleRowClick}
        hoverable={true}
        stripped={true}
        fixedHeader={true}
      />
    </div>
  );
}

export default BatchListView;